var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26,
    rx: 4.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26,
    rx: 4.5,
    stroke: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1435 5.88574C17.2933 5.88574 20.658 9.29422 20.658 13.5C20.658 15.2586 20.0688 16.8786 19.0807 18.1679C19.4178 18.3173 19.7424 18.5466 20.0732 18.7803C20.8807 19.3511 21.7444 19.9609 23.1822 18.533L23.7867 19.1554C21.8374 21.0925 20.6714 20.2689 19.5814 19.4988C19.1916 19.2234 18.8142 18.957 18.3904 18.9516C17.0366 20.2898 15.1857 21.1143 13.1452 21.1143C8.99275 21.1134 5.62891 17.7049 5.62891 13.5C5.62891 9.29512 8.99275 5.88574 13.1435 5.88574ZM13.1435 12.478C13.7005 12.478 14.1512 12.9355 14.1512 13.4991C14.1512 14.0626 13.6996 14.5202 13.1435 14.5202C12.5873 14.5202 12.1357 14.0626 12.1357 13.4991C12.1357 12.9355 12.5873 12.478 13.1435 12.478ZM7.43869 10.1622C7.93585 9.28969 9.03656 8.9907 9.89764 9.49445C10.7587 9.9982 11.0538 11.1135 10.5566 11.986C10.0595 12.8585 8.95877 13.1575 8.09769 12.6538C7.23661 12.15 6.94154 11.0347 7.43869 10.1622ZM7.43869 16.8369C6.94154 15.9644 7.23661 14.8491 8.09769 14.3453C8.95877 13.8416 10.0595 14.1406 10.5566 15.0131C11.0538 15.8856 10.7587 17.0009 9.89764 17.5046C9.03656 18.0084 7.93585 17.7094 7.43869 16.8369ZM13.1435 20.1738C12.1491 20.1738 11.3435 19.3575 11.3435 18.35C11.3435 17.3425 12.1491 16.5261 13.1435 16.5261C14.1378 16.5261 14.9434 17.3425 14.9434 18.35C14.9434 19.3575 14.1378 20.1738 13.1435 20.1738ZM18.8482 16.8369C18.3511 17.7094 17.2504 18.0084 16.3893 17.5046C15.5282 17.0009 15.2331 15.8856 15.7303 15.0131C16.2274 14.1406 17.3281 13.8416 18.1892 14.3453C19.0503 14.8491 19.3454 15.9644 18.8482 16.8369ZM18.8482 10.1622C19.3454 11.0347 19.0503 12.15 18.1892 12.6538C17.3281 13.1575 16.2274 12.8585 15.7303 11.986C15.2331 11.1135 15.5282 9.9982 16.3893 9.49445C17.2504 8.9907 18.3511 9.28969 18.8482 10.1622ZM13.1435 6.82529C14.1378 6.82529 14.9434 7.64162 14.9434 8.64913C14.9434 9.65663 14.1378 10.473 13.1435 10.473C12.1491 10.473 11.3435 9.65663 11.3435 8.64913C11.3435 7.64162 12.1491 6.82529 13.1435 6.82529Z",
    fill: "#6F6B7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoll);
export default __webpack_public_path__ + "static/media/roll.284d28047fa15871652d43cae1c3da59.svg";
export { ForwardRef as ReactComponent };